import { DISPLAY_CURRENCY_TOGGLE_ID } from "testIds";
import React, { CSSProperties } from "react";
import { DISPLAY_CURRENCIES } from "common/constants";
import styled from "styled-components";
import { BTC } from "common/Icons/Icons";
import { Bitcoin, DollarSign } from "lucide-react";
import LookIcon from "common/Icons/LookIcon.tsx";
import { useDispatch, useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants";
import { sharedLib } from "@shared/services/shared.service.js";

interface DisplayCurrencyToggleProps {
  style?: CSSProperties;
}

const DisplayCurrencyToggle = ({ style }: DisplayCurrencyToggleProps) => {
  const dispatch = useDispatch();
  const currencies = Object.keys(DISPLAY_CURRENCIES);
  const displayCurrency = useSelector(selectDisplayCurrency);

  const handleClick = () => {
    const nextIndex =
      (currencies.indexOf(displayCurrency) + 1) % currencies.length;
    dispatch(
      sharedLib.slices.common.actions.setDisplayCurrency(currencies[nextIndex])
    );
  };

  return (
    <Wrapper
      data-testid={DISPLAY_CURRENCY_TOGGLE_ID}
      onClick={handleClick}
      style={style}
    >
      {displayCurrency === DISPLAY_CURRENCIES.BTC ? (
        <LookIcon
          classic={<BTC />}
          newLook={<Bitcoin size={20} strokeWidth={1.75} />}
        />
      ) : (
        <LookIcon
          classic={<Dollar>$</Dollar>}
          newLook={<DollarSign size={20} strokeWidth={1.75} />}
        />
      )}
    </Wrapper>
  );
};

export default DisplayCurrencyToggle;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  width: 20px;
  font-size: ${HEADER_ICON_SIZE};
`;

const Dollar = styled.div`
  margin-bottom: 2px;
`;
